import { observer } from 'mobx-react-lite';
import React from 'react';
import { ITagProps, Tag } from '../../npaper';
import { ISale, SaleStatus } from '../../stores';

export interface ISalesStatusTagProps extends ITagProps {
  sale: ISale;
}

export const SaleStatusTag: React.FC<ISalesStatusTagProps> = observer(
  ({ sale, ...props }) => (
    <Tag intent={sale.statusIntent} {...props}>
      {sale.status === SaleStatus.DRAFT
        ? 'Kladde'
        : sale.status === SaleStatus.OPEN
        ? 'Åben'
        : sale.status === SaleStatus.LOST
        ? 'Tabt'
        : sale.status === SaleStatus.WON
        ? 'Vundet'
        : sale.status === SaleStatus.INVOICED
        ? 'Faktureret'
        : sale.status === SaleStatus.VOID
        ? 'Annulleret'
        : 'Ups...'}
    </Tag>
  )
);
